import { lazyRouteComponent } from "@tanstack/react-router";

import type { PageDef } from "@/app/registry";

/** Accept an RA's invitation from the emailed link; works signed out (V035). */
export const pages: PageDef[] = [];

export const publicPages: PageDef[] = [
  {
    path: "/accept-invite",
    title: "Accept invitation",
    component: lazyRouteComponent(() => import("./AcceptInvitePage"), "AcceptInvitePage"),
    validateSearch: (s) => ({
      ...(typeof s.c === "string" || typeof s.c === "number" ? { c: String(s.c) } : {}),
      ...(typeof s.t === "string" ? { t: s.t } : {}),
    }),
  },
];
